module.exports = __webpack_public_path__ + "141d4a85/img/boston-lights.a623432f.png";